import { useState, useEffect } from 'react';
import { Box, Paper, Stepper, Step, StepLabel, Button, Typography, Snackbar, Alert, FormControlLabel, Switch, IconButton, Divider } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import ClientDetails from './components/ClientDetails';
import ProductDetails from './components/ProductDetails';
import ConsignerDetails from './components/ConsignerDetails';
import TransporterDetails from './components/TransporterDetails';
import ExportDetails from './components/ExportDetails';
import InquiryReview from './components/InquiryReview';
import { useAuth } from '../../context/AuthContext';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from 'axios';
import { getCurrentFYear } from '../../utils/financialYear';

const steps = ['Client Details', 'Product Details', 'Dispatch Details', 'Review & Submit'];

/**
 * Robust deep merge utility (immutable).
 *
 * Supported options:
 *   - arrayMerge: "replace" | "concat" | "mergeByIndex"  (default: "replace")
 *   - preservePrototype: boolean (default: false) - usually false is safer
 *
 * Behavior highlights:
 *  - Plain objects are merged recursively.
 *  - Arrays handled by chosen strategy.
 *  - Dates & RegExps are cloned.
 *  - Functions / other non-plain objects are copied by reference.
 *  - Circular refs are preserved (WeakMap).
 */
// function isPlainObject(value) {
//     return Object.prototype.toString.call(value) === '[object Object]';
// }

// function cloneValue(value, refs = new WeakMap()) {
//     if (value === null || value === undefined) return value;
//     if (value instanceof Date) return new Date(value.getTime());
//     if (value instanceof RegExp) return new RegExp(value.source, value.flags);
//     if (Array.isArray(value)) return value.map(v => cloneValue(v, refs));
//     if (isPlainObject(value)) return mergeDeep({}, value, { arrayMerge: 'replace' }, refs);
//     // For functions and other objects (Map, Set, Buffer, custom class) return as-is (reference)
//     return value;
// }

// function mergeDeep(target = {}, source = {}, options = {}, refs = null) {
//     const { arrayMerge = 'replace', preservePrototype = false } = options;
//     // Use WeakMap to track visited nodes and avoid infinite recursion on circular refs
//     if (!refs) refs = new WeakMap();

//     // Primitive shortcut
//     if (!isPlainObject(source) && !Array.isArray(source)) {
//         // if source is Date/RegExp we want cloned instance
//         return cloneValue(source, refs);
//     }

//     // If circular reference already present, return recorded ref
//     if (refs.has(source)) return refs.get(source);

//     // Prepare result copy (do not mutate inputs)
//     let output;
//     if (Array.isArray(source)) {
//         // If target isn't an array, start fresh (do not try to treat objects like arrays)
//         const left = Array.isArray(target) ? target.slice() : [];
//         if (arrayMerge === 'replace') {
//             output = source.map(v => cloneValue(v, refs));
//         } else if (arrayMerge === 'concat') {
//             output = left.map(v => cloneValue(v, refs)).concat(source.map(v => cloneValue(v, refs)));
//         } else if (arrayMerge === 'mergeByIndex') {
//             const max = Math.max(left.length, source.length);
//             output = new Array(max);
//             refs.set(source, output);
//             for (let i = 0; i < max; i++) {
//                 if (i in source && i in left) {
//                     output[i] = mergeDeep(left[i], source[i], options, refs);
//                 } else if (i in source) {
//                     output[i] = cloneValue(source[i], refs);
//                 } else {
//                     output[i] = cloneValue(left[i], refs);
//                 }
//             }
//             return output;
//         } else {
//             // unknown strategy -> replace
//             output = source.map(v => cloneValue(v, refs));
//         }
//         refs.set(source, output);
//         return output;
//     }

//     // source is plain object
//     output = preservePrototype ? Object.create(Object.getPrototypeOf(target || {})) : {};
//     refs.set(source, output);

//     // copy keys from target first (so source overwrites)
//     if (isPlainObject(target)) {
//         for (const k of Object.keys(target)) {
//             output[k] = cloneValue(target[k], refs);
//         }
//     }

//     // merge keys from source
//     for (const key of Object.keys(source)) {
//         const sVal = source[key];
//         const tVal = (isPlainObject(target) && key in target) ? target[key] : undefined;

//         if (isPlainObject(sVal)) {
//             output[key] = mergeDeep(isPlainObject(tVal) ? tVal : {}, sVal, options, refs);
//             continue;
//         }

//         if (Array.isArray(sVal)) {
//             // Choose strategy relative to target
//             if (arrayMerge === 'mergeByIndex' && Array.isArray(tVal)) {
//                 // merge arrays item wise
//                 const max = Math.max(tVal.length, sVal.length);
//                 const arr = new Array(max);
//                 refs.set(sVal, arr);
//                 for (let i = 0; i < max; i++) {
//                     if (i in sVal && i in tVal) arr[i] = mergeDeep(tVal[i], sVal[i], options, refs);
//                     else if (i in sVal) arr[i] = cloneValue(sVal[i], refs);
//                     else arr[i] = cloneValue(tVal[i], refs);
//                 }
//                 output[key] = arr;
//             } else if (arrayMerge === 'concat' && Array.isArray(tVal)) {
//                 output[key] = (tVal || []).map(v => cloneValue(v, refs)).concat(sVal.map(v => cloneValue(v, refs)));
//             } else {
//                 // replace
//                 output[key] = sVal.map(v => cloneValue(v, refs));
//             }
//             continue;
//         }

//         // handle Date/RegExp/cloned primitives
//         output[key] = cloneValue(sVal, refs);
//     }

//     return output;
// }

// Utility function for deep merging objects
const deepMerge = (target, source) => {
    const output = { ...target };
    for (const key in source) {
        if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
            output[key] = deepMerge(target[key] || {}, source[key]);
        } else {
            output[key] = source[key];
        }
    }
    return output;
};

// let path = `http://103.251.218.254:91/api`;

const InvoiceMaster = ({ companyData, mode, connectionString, onPopupCancel }) => {
    const { user, selectedCompany, loading } = useAuth();
    const userId = user?.UserId;
    const companyId = selectedCompany?.CompId || null;
    const AppRegID = selectedCompany?.AppRegID || null;
    const fYear = getCurrentFYear();
    let path = connectionString;

    const { clientId, saleInvoiceId } = useParams();
    const { state } = useLocation();
    const navigate = useNavigate();
    // console.log(mode);
    const [activeStep, setActiveStep] = useState(0);
    const [formData, setFormData] = useState({});
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [consignerEnabled, setConsignerEnabled] = useState(true);
    const [transporterEnabled, setTransporterEnabled] = useState(true);
    const [exportEnabled, setExportEnabled] = useState(false);
    const [creditNoteExists, setCreditNoteExists] = useState(false);
    const [isLocked, setIsLocked] = useState(false);
    const [lockReason, setLockReason] = useState('');

    // // In your component file (replace previous deepMerge)
    // function mergeFormData(prev, stepData) {
    //     // stepData is expected to be a "partial" object like { client: {...} } or { product: {...} }
    //     // We intentionally replace arrays (most multi-step forms replace entire arrays from a single step).
    //     return mergeDeep(prev || {}, stepData || {}, { arrayMerge: 'replace', preservePrototype: false });
    // }

    // // Usage in handleNext
    // const handleNext = (stepData = {}) => {
    //     console.log('Step data:', stepData);
    //     setFormData(prev => mergeFormData(prev, stepData));
    //     setActiveStep(prev => prev + 1);
    // };

    const handleNext = (stepData = {}) => {
        console.log('Step data:', stepData);
        setFormData(prev => deepMerge(prev, stepData));
        setActiveStep(prev => prev + 1);
    };

    const challanIds = state?.selectedChallanAutoIDs || []   // ✅ include challan IDs

    // ── on mount, fetch existing challan and seed formData ────────────────────────
    useEffect(() => {
        if (mode === 'ref' && state?.selectedChallanAutoIDs) {
            const challanIds = state.selectedChallanAutoIDs;
            if (challanIds.length === 0) {
                setSnackbar({ open: true, message: 'No challans selected.', severity: 'error' });
                return;
            }
            const data = { clientId, challanIds }
            console.log(data);
            axios.post(`${path}/api/challans`, data)
                .then(({ data }) => {
                    console.log('Fetched data:', data);

                    // Set the entire response as formData
                    setFormData(data);

                    // Show a success snackbar
                    // setSnackbar({ open: true, message: 'Sales order data fetched successfully!', severity: 'success', });
                })
                .catch(err => {
                    console.error('Failed to load challan', err);
                    setSnackbar({ open: true, message: 'Failed to load Challan', severity: 'error' });
                });
        }
    }, [clientId]);

    useEffect(() => {
        if (mode === 'edit') {
            // console.log(saleInvoiceId);
            // Send GET request with ID in query params
            axios.get(`${path}/api/invoice-getinfo`, { params: { saleInvoiceId } })
                .then(res => {
                    console.log("Invoice Data:", res.data);
                    setFormData(res.data);
                    // Set enabled states based on whether fields are null
                    setConsignerEnabled(res.data.consigner !== null);
                    setTransporterEnabled(res.data.transporter !== null || res.data.consigner !== null);
                    setExportEnabled(res.data.export !== null);

                    // Check if invoice is locked due to billwiseentry
                    if (res.data.isLocked) {
                        setIsLocked(true);
                        setLockReason(res.data.lockReason || 'This invoice cannot be edited');
                        setSnackbar({ open: true, message: 'This invoice is locked and cannot be edited', severity: 'warning' });
                    } else {
                        setIsLocked(false);
                        setLockReason('');
                    }
                })
                .catch(err => { console.error("Error fetching invoice:", err); });
        }
    }, [saleInvoiceId]);

    useEffect(() => {
        if (mode !== 'edit' || !saleInvoiceId) return;

        const checkCreditNoteExists = async () => {
            try {
                const res = await axios.get(
                    `${path}/api/creditnote-exists`,
                    { params: { saleInvoiceId } }
                );

                console.log('Credit note check:', res.data);

                if (res.data?.creditNoteExists) {
                    setCreditNoteExists(true);
                    // setSnackbar({
                    //     open: true,
                    //     severity: 'warning',
                    //     message: 'Credit Note is already exist. User can not edit this record.'
                    // });
                }
            } catch (err) {
                console.error('Credit note check failed', err);
            }
        };

        checkCreditNoteExists();
    }, [mode, saleInvoiceId]);


    const handleBack = () => setActiveStep(prev => prev - 1);

    const handleSubmit = async () => {
        if (isLocked) {
            setSnackbar({ open: true, message: 'Cannot submit. This invoice is locked.', severity: 'error' });
            return;
        }

        try {
            const payload = { client: formData.client, product: formData.product, consigner: transporterEnabled ? formData.consigner : null, transporter: transporterEnabled ? formData.transporter : null, export: exportEnabled ? formData.export : null, clientId, companyId, userId, AppRegID, fYear };

            console.log(payload);

            if (mode === 'add' || mode === 'ref') {
                await axios.post(`${path}/api/create-invoice-from-challan`, payload);
            }
            if (mode === 'edit') {
                await axios.put(`${path}/api/invoice-update/${saleInvoiceId}`, payload);
            }

            setSnackbar({
                open: true,
                message: mode === 'add' ? 'Sale Invoice created successfully!' : 'Sale Invoice updated successfully!',
                severity: 'success',
            });

            setActiveStep(0);
            setFormData({});
            setTimeout(() => {
                if (typeof onPopupCancel === "function") onPopupCancel();
                else navigate(-1);
            }, 600);
        } catch (error) {
            console.error(error);
            setSnackbar({ open: true, message: 'Failed to submit Sale Invoice.', severity: 'error' });
        }
    };

    const handleCancel = () => {
        if (typeof onPopupCancel === "function") {
            onPopupCancel();
        } else {
            navigate(-1);
        }
    };

    // Sync activeStep with URL changes (e.g., browser back button).
    // Note: by the time popstate fires, the browser has ALREADY moved history
    // back one entry — calling handleCancel()/navigate(-1) here would pop a
    // SECOND entry on top of that, overshooting past the intended page. Just
    // reset local wizard state; the browser's own navigation handles the page.
    useEffect(() => {
        const handlePopState = () => {
            setActiveStep(0);
        };
        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, []);

    // ──────────────── Alt+C (Cancel) shortcut — works from any step ───────────
    // Attached here (the wizard's parent), not per-step, so it works regardless
    // of which step (Client Details / Product Details / Dispatch Details /
    // Review) is active — those step components don't each carry their own
    // cancel concept.
    // Attached to document in the capture phase so it fires regardless of which
    // field/dropdown currently has focus, including MUI popper/portal content.
    // Uses e.code (physical key position) instead of e.key so this also works on
    // macOS, where Option+letter often produces an accented/dead-key character
    // via e.key (e.g. Option+C → "ç") instead of the plain letter.
    useEffect(() => {
        const handleGlobalKeyDown = (e) => {
            if (!e.altKey || e.code !== "KeyC") return;
            e.preventDefault();
            handleCancel();
        };

        document.addEventListener("keydown", handleGlobalKeyDown, true);
        return () => document.removeEventListener("keydown", handleGlobalKeyDown, true);
    }, [handleCancel]);

    const disablePartyName =
        Array.isArray(formData?.product?.tableData) &&
        formData.product.tableData.some(
            row => row?.challanDtsID != null || row?.challanID != null
        );


    const handleCloseSnackbar = () => setSnackbar(prev => ({ ...prev, open: false }));

    const renderStepHeader = (icon, title, control = null) => (
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Box display="flex" alignItems="center">
                {activeStep > 0 && (
                    <IconButton onClick={handleBack} size="small" sx={{ mr: 1 }}>
                        <ArrowBack />
                    </IconButton>
                )}
                <Typography variant="h6" fontWeight="bold">{icon} {title}</Typography>
            </Box>
            {control}
        </Box>
    );

    // const getStepComponent = (step) => {
    //     switch (step) {
    //         case 0: return (<>
    //         {renderStepHeader('1️⃣', 'Client Details')}
    //         <ClientDetails connectionString={connectionString} mode={mode} initialData={formData.client || {}} onNext={(data) => handleNext({ client: data })} disablePartyName={disablePartyName} /> </>);

    //         case 1:
    //             return (
    //                 <>
    //                     {renderStepHeader('2️⃣', 'Product Details')}
    //                     <ProductDetails connectionString={connectionString} initialData={formData.product || {}} onNext={(data) => handleNext({ product: data })} companyData={companyData} clientData={formData.client || {}} challanIds={challanIds} />
    //                 </>
    //             );

    //         case 2:
    //             return (
    //                 <>
    //                     {renderStepHeader('3️⃣', 'Consigner & Consignee',
    //                         <FormControlLabel control={
    //                             <Switch checked={consignerEnabled} onChange={e => setConsignerEnabled(e.target.checked)} />
    //                         } label="Enable" />
    //                     )}
    //                     {consignerEnabled ? (
    //                         <ConsignerDetails connectionString={connectionString} clientData={formData.client || {}} mode={mode} initialData={formData.consigner || {}} onNext={data => handleNext({ consigner: data })} onBack={handleBack} companyData={companyData} />
    //                     ) : (
    //                         <Box mt={2}>
    //                             <Typography color="text.secondary">Consigner details are skipped.</Typography>
    //                             <Button variant="contained" onClick={() => handleNext({})}>Continue</Button>
    //                         </Box>
    //                     )}
    //                 </>
    //             );

    //         case 3:
    //             return (
    //                 <>
    //                     {renderStepHeader('4️⃣', 'Dispatch Details',
    //                         <FormControlLabel control={
    //                             <Switch checked={transporterEnabled} onChange={e => setTransporterEnabled(e.target.checked)} />
    //                         } label="Enable" />
    //                     )}
    //                     {transporterEnabled ? (
    //                         <TransporterDetails connectionString={connectionString} mode={mode} initialData={formData.transporter || {}} onNext={data => handleNext({ transporter: data })} onBack={handleBack} companyData={companyData} />
    //                     ) : (
    //                         <Box mt={2}>
    //                             <Typography color="text.secondary">Dispatch details are skipped.</Typography>
    //                             <Button variant="contained" onClick={() => handleNext({})}>Continue</Button>
    //                         </Box>
    //                     )}
    //                 </>
    //             );

    //         case 4:
    //             return (
    //                 <>
    //                     {renderStepHeader('5️⃣', 'Export Details',
    //                         <FormControlLabel control={
    //                             <Switch checked={exportEnabled} onChange={e => setExportEnabled(e.target.checked)} />
    //                         } label="Enable" />
    //                     )}
    //                     {exportEnabled ? (
    //                         <ExportDetails connectionString={connectionString} mode={mode} initialData={formData.export || {}} onNext={data => handleNext({ export: data })} onBack={handleBack} companyData={companyData} />
    //                     ) : (
    //                         <Box mt={2}>
    //                             <Typography color="text.secondary">Export details are skipped.</Typography>
    //                             <Button variant="contained" onClick={() => handleNext({})}>Continue</Button>
    //                         </Box>
    //                     )}
    //                 </>
    //             );

    //         case 5: return (<InquiryReview formData={formData} selectedCompany={selectedCompany} onBack={handleBack} onSubmit={handleSubmit} onEditStep={(stepIndex) => setActiveStep(stepIndex)} connectionString={connectionString} mode={mode} />);

    //         default: return null;
    //     }
    // };


    const getStepComponent = (step) => {
        switch (step) {
            case 0: return (<>
                {renderStepHeader('1️⃣', 'Client Details')}
                <ClientDetails connectionString={connectionString} mode={mode} initialData={formData.client || {}} onNext={(data) => handleNext({ client: data })} disablePartyName={disablePartyName || isLocked} creditNoteExists={creditNoteExists} disabled={isLocked} /> </>);

            case 1:
                return (
                    <>
                        {renderStepHeader('2️⃣', 'Product Details')}
                        <ProductDetails connectionString={connectionString} initialData={formData.product || {}} onNext={(data) => handleNext({ product: data })} L_No={formData.L_No || null} companyData={companyData} clientData={formData.client || {}} challanIds={challanIds} mode={mode} creditNoteExists={creditNoteExists} disabled={isLocked} 
                             onRowsChange={(rows) => {
                                setFormData(prev => ({
                                    ...prev,
                                    product: {
                                        ...(prev.product || {}),
                                        tableData: rows,
                                    }
                                }));
                            }}/>
                    </>
                );



            /* COMBINED STEP (Step 2 consignee and despatch details) */
            case 2:
                return (
                    <>
                        {renderStepHeader('3️⃣', 'Dispatch Details', (<FormControlLabel control={<Switch checked={transporterEnabled} onChange={e => setTransporterEnabled(e.target.checked)} />} label="Enable" />))}
                        {transporterEnabled ? (
                            <>
                                <Box sx={{ display: 'flex', flexDirection: "column", gap: 4 }}>
                                    <ConsignerDetails
                                        clientData={formData.client || {}}
                                        initialData={formData.consigner}
                                        connectionString={connectionString}
                                        onChange={(data) =>
                                            setFormData(prev => ({ ...prev, consigner: data }))
                                        }
                                        companyData={companyData}
                                        disabled={isLocked}
                                    />

                                    <TransporterDetails
                                        initialData={formData.transporter || {}}
                                        connectionString={connectionString}
                                        onChange={(data) =>
                                            setFormData(prev => ({
                                                ...prev,
                                                transporter: data
                                            }))

                                        }
                                        companyData={companyData}
                                        // disabled={isLocked}
                                    />
                                </Box>


                                {/* ✅ SINGLE NEXT BUTTON */}
                                <Box mt={3} display="flex" justifyContent="flex-end">
                                    <Button
                                        variant="contained"
                                        // disabled={isLocked}
                                        onClick={() => {
                                            // if (isLocked) {
                                            //     setSnackbar({ open: true, message: 'Cannot proceed. This invoice is locked.', severity: 'error' });
                                            //     return;
                                            // }
                                            handleNext({
                                                consigner: formData.consigner,
                                                transporter: formData.transporter
                                            });
                                        }}
                                    >
                                        Next
                                    </Button>
                                </Box>

                            </>
                        ) : (
                            <Box mt={2}>
                                <Typography color="text.secondary">Dispatch details are skipped.</Typography>
                                <Button variant="contained" onClick={() => {
                                    handleNext({})
                                }}>Continue</Button>
                            </Box>
                        )}

                    </>
                );


            case 3: return (<InquiryReview formData={formData} selectedCompany={selectedCompany} onBack={handleBack} onSubmit={handleSubmit} onEditStep={(stepIndex) => setActiveStep(stepIndex)} connectionString={connectionString} mode={mode} creditNoteExists={creditNoteExists} isBillwiseEntryExists={isLocked} />);

            default: return null;
        }
    };
    return (
        <Box maxWidth="lg" mx="auto" px={2} py={1}>
            {/* <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600, mb: 1 }}>
                {mode === 'edit' ? 'Edit Invoice' : 'Add New Invoice'}
            </Typography> */}

            <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 0.6, mt: -1.5 }}>
                {/* Back arrow — mobile/tablet only */}
                <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 0, display: { xs: 'flex', md: 'none' }, color: 'text.secondary', p: 0.5, }} >
                    <ArrowBackIcon fontSize="small" />
                </IconButton>

                <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600 }}>
                    {mode === 'edit' ? 'Edit Invoice' : 'Add New Invoice'}
                </Typography>
            </Box>

            <Paper elevation={4} sx={{ borderRadius: 3, p: 1.5 }}>
                {isLocked && (
                    <Alert severity="error" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                        🔒 {lockReason || 'This invoice is locked and cannot be edited'}
                    </Alert>
                )}
                {creditNoteExists && (
                    <Alert severity="warning" sx={{ mb: 1 }}>
                        Credit Note is already created. Client Details and Product Details can not be modified.
                    </Alert>
                )}
                <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 1 }}>
                    {steps.map(label => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>

                <Divider sx={{ mb: 0.5 }} />
                {getStepComponent(activeStep)}
            </Paper>

            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} variant="filled">
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default InvoiceMaster;